
import React from 'react';
import { Bot, FileText, GitBranch, Rocket, Palette, GitMerge } from 'lucide-react';
import { useBreakpoint } from '@/hooks/use-mobile';
import FeatureCard from './FeatureCard';

const FeaturesGrid: React.FC = () => {
  const { isMobile } = useBreakpoint();
  
  const features = [
    {
      icon: <Bot size={isMobile ? 20 : 32} />,
      title: "Custom AI Assistants",
      description: "Train AI-powered assistants with your data to handle FAQs, customer inquiries, and automation—deployed anywhere in minutes.",
      delay: "0s"
    },
    {
      icon: <FileText size={isMobile ? 20 : 32} />,
      title: "IntelliForm",
      description: "AI-enhanced forms that dynamically adapt to user input, generate intelligent responses, and automate workflows for lead capture and support.",
      delay: "0.1s"
    },
    {
      icon: <GitBranch size={isMobile ? 20 : 32} />,
      title: "Flow Builder",
      description: "A no-code drag-and-drop tool for designing structured AI-powered conversations and automation flows.",
      delay: "0.2s"
    },
    {
      icon: <Rocket size={isMobile ? 20 : 32} />,
      title: "Easy Deployment",
      description: "Embed AI tools on websites, share via direct links, or integrate into messaging platforms for effortless accessibility.",
      delay: "0.3s"
    },
    {
      icon: <Palette size={isMobile ? 20 : 32} />,
      title: "White-Label Branding",
      description: "Customize AI solutions with your own logo, domain, and brand colors for a seamless branded experience.",
      delay: "0.4s"
    },
    {
      icon: <GitMerge size={isMobile ? 20 : 32} />,
      title: "Powerful Integrations",
      description: "Connect AskSpot with CRMs, automation platforms, and third-party apps using webhooks and API integrations.",
      delay: "0.5s"
    }
  ];
  
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-7 lg:gap-10 mb-10 md:mb-16 relative z-10 px-2 sm:px-0">
      {features.map((feature, index) => (
        <FeatureCard
          key={index}
          icon={feature.icon}
          title={feature.title}
          description={feature.description}
          delay={feature.delay}
          isMobile={isMobile}
        />
      ))}
    </div>
  );
};

export default FeaturesGrid;
